import * as React from "react";
import { createContext, useContext, useState, useCallback } from "react";

interface AnalysisGuardContextType {
  isAnalysisInProgress: boolean;
  setAnalysisInProgress: (value: boolean) => void;
}

const AnalysisGuardContext = createContext<AnalysisGuardContextType>({
  isAnalysisInProgress: false,
  setAnalysisInProgress: () => {},
});

export const AnalysisGuardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAnalysisInProgress, setAnalysisInProgressState] = useState(false);

  const setAnalysisInProgress = useCallback((value: boolean) => {
    setAnalysisInProgressState(value);
  }, []);

  return (
    <AnalysisGuardContext.Provider value={{ isAnalysisInProgress, setAnalysisInProgress }}>
      {children}
    </AnalysisGuardContext.Provider>
  );
};

export const useAnalysisGuard = () => useContext(AnalysisGuardContext);
